var map = {
	"./wired-outline-1683-recycling-black.json": 329,
	"./wired-outline-1683-recycling.json": 19,
	"./wired-outline-185-trash-bin-black.json": 691,
	"./wired-outline-185-trash-bin.json": 945,
	"./wired-outline-212-arrow-1-rounded.json": 793,
	"./wired-outline-213-arrow-2-rounded-black.json": 685,
	"./wired-outline-35-edit-black.json": 459,
	"./wired-outline-35-edit.json": 769,
	"./wired-outline-49-plus-circle-black.json": 373,
	"./wired-outline-49-plus-circle.json": 879,
	"./wired-outline-50-minus-circle-black.json": 483,
	"./wired-outline-50-minus-circle.json": 897
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 506;